<template>
<section class="Section NoTopPadding">
			<div class="Container">
				<div class="BoxWide">
					<div class="BookingPanel">
						<booking-navigator></booking-navigator>
						<div class="BookingContent">
							<booking-description></booking-description>
							<div class="BookingCalendar">

                                <DxCalendar ref="calendar"
                                    id="calendar-container"                                                                       
                                    :disabled-dates="disabledDates"
                                    :first-day-of-week="firstDay"                                    
                                    :zoom-level="zoomLevel"
                                    :cell-template="cellTemplate"
                                    @valueChanged="calendarValueChanged"
                                    @optionChanged="calendarOptionChanged"
                                    v-model:value="currentValue"
                                    >
                                    <template #custom="{ data: cell }">
                                    <span :class="getCellCssClass(cell.date)">
                                        {{ cell.text }}
                                    </span>
                                    </template>
                                </DxCalendar>
                                <DxPopup 
                                    v-model:visible="popupVisible"
                                    :drag-enabled="false"
                                    :close-on-outside-click="true"
                                    :show-title="true"
                                    :width="300"
                                    :height="200"
                                    title="Selezione Orario"
                                    @hiding="popUpHiding"
                                    >
                                    <p>
                                        Scegli una fascia oraria
                                    </p>    
                                        <select v-model="idOrario" class="field" id="selectOrari" @change="selectOrariChange">
                                            <option value="" >Scegli</option>
                                            <option v-for="fascia in daysFree[giorno]" :value="fascia.IdOrario" :key="fascia.IdOrario">{{fascia.OraInizio}}</option>
                                        </select>
                                </DxPopup>
                                <DxToast
                                        v-model:visible="isToastVisible"                                        
                                        v-model:message="msgErrore"
                                        type="error"
                                        :height="60"
                                        :width="500"
                                        :displayTime= "3000"
                                        position="center"							
                                    >                                    
                               </DxToast>
                            </div>
										
						</div>
						<div class="BookingContent">
							<div class="BookingPriceTable">
								<div>
									<table width="100%" border="0" cellspacing="0" cellpadding="1">
										<tbody>
											<tr>
												<th scope="col">Data della visita</th>
												<th scope="col">Fascia Oraria</th>
											</tr>
											<tr>
												<td>{{  giornoCompleto }}</td>												
												<td>{{  orarioCompleto }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="Button TwinButton">
                                <a href="javascript:void(0)" @click="annullaPrenotazione">Cambia Giorno</a> 
                                <router-link to="/BookingForm" tag="a">Conferma</router-link>
                                </div>							
						</div>
					</div>
				</div>
			</div>
		</section>
</template>

<script>



import BookingNavigator from '@/components/BookingNavigator.vue'
import BookingDescription from '@/components/BookingDescription.vue'
import  { DxPopup }  from 'devextreme-vue/popup';
import { DxCalendar } from 'devextreme-vue/calendar';
import { DxToast } from 'devextreme-vue/toast';
import WebApiService from "@/services/webapi.service.js";


export default{
    name: "BookingCalendar",
    components:{
        BookingNavigator,
        BookingDescription,
        DxCalendar,
        DxPopup,
        DxToast       
    },
    data(){
        return {           
            disabledDates: null,
            firstDay: 0,
            currentValue: new Date(),           
            cellTemplate: 'custom',            
            zoomLevel: 'month',
            daysFree: [],
            popupVisible: false,
            isToastVisible: false,
            msgErrore: ""
        }
    },
    computed: {
        giornoCompleto(){
            return this.$store.getters.getGiornoCompleto;
        },
        orarioCompleto(){
            return this.$store.getters.getOrarioCompleto;
        },
        idOrario(){
            return this.$store.getters.getIdOrario;
        },
        giorno(){            
            return this.$store.getters.getGiorno;
        }
    },
    methods:{    

        annullaPrenotazione(){

            this.$store.commit("setGiorno", "");
            this.$store.commit("setIdOrario", "");
            this.$store.commit("setOrario", "");
        },    
        selectOrariChange(event){
            
            this.$store.commit("setIdOrario", event.target.value);          
           
            let currentOrario = this.daysFree[ this.$store.getters.getGiorno].find((elem) => {               
                return elem.IdOrario === parseInt(this.$store.getters.getIdOrario);
            }).OraInizio;

            this.$store.commit("setOrario", currentOrario);
            this.popupVisible = false;            
        },   
        popUpHiding(){
          let dataSel = new Date(this.$store.getters.getGiorno);
          dataSel.setDate(dataSel.getDate()+1);
          this.currentValue =  dataSel;        
        },
        getCellCssClass(date){
            let dateKey = this. strFromDate(date, "yyyy-mm-dd");           
            let cssClass = ''; 

            if(this.daysFree[dateKey]){                            
                cssClass = "day-free";
            }         
            return cssClass;
        },
        strFromDate(date, format){
            let year = date.getFullYear();
            let month = (date.getMonth()+1);
            let day = date.getDate();

            if(month < 10 ) month = "0" + month;
            if(day < 10) day = "0" + day;

            if(format == "yyyy-mm-dd"){
                return year + "-" + month + "-" +day;
            }
            else{
                return day + "/" + month + "/" + year;
            }            
        },
        leapyear(year){
            return (year % 100 === 0) ? (year % 400 === 0) : (year % 4 === 0);
        },
        getLastDayMonth(month, year){
            if(month == 2 && this.leapyear(year)){
                return 29;
            }
            else if(month == 2 && !this.leapyear(year)){
                return 28;
            }
            else if(month == 11 || month == 4 || month == 6 || month == 9){
                return 30;
            }
            else{
                return 31;
            }
        },
        calendarValueChanged(e){

            let dateKey = this.strFromDate(e.value, "yyyy-mm-dd");           
            if(this.daysFree[dateKey]){               
               
                this.$store.commit("setGiorno", dateKey)
                this.popupVisible = true;   
                this.$store.commit("setIdOrario", "");
                this.$store.commit("setOrario", "");            
            }           
        },
        calendarOptionChanged(e){
           // debugger;
            if(e.value && e.previousValue && e.value != e.previousValue){

                let dtInizio = new Date(e.value.getFullYear(), e.value.getMonth(), 1);
                let dtFine = new Date(e.value.getFullYear(),  e.value.getMonth(), this.getLastDayMonth(e.value.getMonth()));

                let params = {
                    idCentro: this.$store.getters.getCentro.IdCentro,
                    dataInizio : this.strFromDate(dtInizio, "yyyy-mm-dd"),
                    dataFine : this.strFromDate(dtFine, "yyyy-mm-dd")
                };

                this.getDisponibilitaCentro(params);
            }
        },
        getDisponibilitaCentro(params){
            WebApiService.get('CentroMedico/GetDisponibilitaCentro', {}, params).then(
                (data) => { 				
                    if(data.StatusCode !== 200){                  
                        console.log(data.Message);
                        this.msgErrore = "Attenzione si è verificato un errore interno al sistema: " + data.Message;
                        this.isToastVisible = true;	
                    }
                    else{	
                        
                        this.daysFree = data.Data;
                    }
                },
                error => {
                    console.log(error);	
                    this.msgErrore = "Attenzione si è verificato un errore interno al sistema!";
                    this.isToastVisible = true;		
                }
                )
                .catch(              
                    error => {
                        console.log(error);		
                        this.msgErrore = "Attenzione si è verificato un errore interno al sistema!";
                        this.isToastVisible = true;					
                    }				
                );
        }        
    },
    mounted:function(){
        
        let now = new Date();
        let dtInizio = new Date(now.getFullYear(), now.getMonth(), 1);
        let dtFine = new Date(now.getFullYear(), now.getMonth(), this.getLastDayMonth(now.getMonth));


        let params = {
            idCentro: this.$store.getters.getCentro.IdCentro,
            dataInizio : this.strFromDate(dtInizio, "yyyy-mm-dd"),
            dataFine : this.strFromDate(dtFine, "yyyy-mm-dd")
        };

        this.getDisponibilitaCentro(params);     

    },  
    beforeRouteLeave(to, from, next){
      
      if(!this.$store.getters?.getCentro?.IdCentro && to.name != "BookingPanelMap"){	
        this.msgErrore = "Attenzione, per proseguire è necessario selezionare un centro medico. Tornare allo step 1 'Scegli un centro'";  	
        this.isToastVisible = true;
		//this.$route.push("/BookingPanelMap")
	  }
      else if((!this.$store.getters.getIdOrario || !this.$store.getters.getGiorno) && to.name == "BookingForm"){        
        this.msgErrore = "Attenzione, per proseguire è necessario selezionare una data ed una fascia oraria";  	
        this.isToastVisible = true;
      }
	  else{
		  next();
	  }
    }
}

</script>

<style scoped>

.field{
    height: 40px;
    background-color: #ffffff;
    border: 1px solid #6FB5A4;
    color: #444444;
    border-radius: 4px;
    padding-right: 18px;
    padding-left: 18px;
    width: 100%;
    
}

.widget-container {
    margin-right: 320px;
}

.BookingContent .Editor {
    margin-bottom:20;
}

#calendar-container {
    margin: auto;
}

.dx-calendar-cell .day-free{
    background: #009688;
    color: #fff;
}

.dx-popup-content p {
  margin-bottom: 10px;
  margin-top: 0;
}


</style>
<style>
.dx-popup-title.dx-toolbar .dx-toolbar-items-container {
    height: 46px !important; 
}

.dx-popup-title.dx-toolbar{
    background: #f4f4f4;
}

.dx-popup-title.dx-toolbar .dx-toolbar-label {
    font-size: 16px;
    font-weight: normal;
}

.dx-calendar-cell.dx-calendar-selected-date span, .dx-calendar-cell.dx-calendar-selected-date.dx-calendar-today span {
    background-color: #fff;
    color: #009688;
    font-weight: 400;
}
    

</style>